<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolTimetableManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/timetable-management/timetable",
                title: "Timetable Setup",
                description: "Create and update class timetables and teaching periods.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Timetable Staff In Charge Setup",
                description: "Assign staff responsible for timetable activities.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
